import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from '@/app/App.vue';
import { createAppRouter } from '@/app/router';
import { api } from '@/lib/api';
import { installBackButton, installSecureStore, isNative } from '@/lib/native';
import { useAuthStore } from '@/stores/auth';
import '@/styles/main.css';

/**
 * Async because the keychain is.
 *
 * On native the refresh token has to be in memory before the router's first navigation runs
 * its guard — the guard calls `auth.restore()`, which asks whether a session exists. Mounting
 * first and hydrating afterwards would show every returning user the login page for a frame
 * and then yank them somewhere else.
 */
async function bootstrap(): Promise<void> {
  const app = createApp(App);
  app.use(createPinia());

  if (isNative()) await installSecureStore();

  // The client signals an unrecoverable session; the store is what holds the user.
  // Wired here because the store needs Pinia, which is only installed above.
  const auth = useAuthStore();
  api.onSessionExpired = () => auth.onSessionExpired();

  const router = createAppRouter();
  app.use(router);

  if (isNative()) await installBackButton(router);

  app.mount('#app');
}

void bootstrap();
